import { Component, OnInit, OnDestroy, Input, Output, Inject, EventEmitter } from '@angular/core';
import { ISubscription } from "rxjs/Subscription";
import { Observable } from 'rxjs/Rx';

import { LoggerService } from '../../services/logger.service';

import { SearchResultItem } from './search-result-item';
import { NavSearchInputProvider } from './nav-search-input.provider';


export class NavSearchInputComponent implements OnInit, OnDestroy {

  public counter : number = -1;
  public focused : boolean = false;
  public results : SearchResultItem[];
  public isSearching : boolean = false;

  private subscription : ISubscription;
  private searchSubscription : ISubscription;

  private previousSearch : string = "";

  public search = {
    title : ""
  }

  constructor(private navSearchInputProvider : NavSearchInputProvider,  private loggerService: LoggerService) { }

  ngOnInit() {
    this.loggerService.log('... initializing NavSearchInput from core module.');
    this.searchSubscription = this.navSearchInputProvider.getSubscription().subscribe((results: SearchResultItem[]) => {
      this.results = results;
      this.isSearching = false;
    });

    this.subscription = Observable.interval(500).subscribe(() => {
      if (this.isSearching) {
        return;
      }

      if (!this.search.title) {
        this.navSearchInputProvider.clear();
        this.counter = -1;
        return;
      }

      if (this.counter > 0) {
        this.counter--;
      }

      if (this.counter != 0) {
        return;
      }

      this.counter--;

      this.isSearching = true;
      this.navSearchInputProvider.search(this.search.title);
      this.previousSearch = this.search.title;

    });

  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.searchSubscription.unsubscribe();
  }

  public onKeyUp() : void {
    this.waitStopWriting();
  }

  public clearSearch() : void {
    this.search.title = "";
    this.navSearchInputProvider.search(this.search.title);
    this.previousSearch = this.search.title;
    this.counter = -1;
  }

  private waitStopWriting() : void {
    if (this.search.title == this.previousSearch){
      return;
    }
    this.counter = 4;
  }

  public onBlur() : void {
    this.focused = false;
  }

  public onFocus() : void {
    this.focused = true;
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: '[leaf-nav-search-input]',
  template: `
    <style>
    .leaf-nav-search .search-results {
      position: relative;
    }

    .leaf-nav-search .search-results ul {
      position: absolute;
      margin: 0px;
      padding: 0px;
      background-color: white;
      width: 100%;
      border-radius: 0px 0px 16px 16px;
      border: 1px solid #cccccc;
      border-top: none;
      list-style-type: none;
      overflow: hidden;
    }

    .leaf-nav-search .search-results ul li {
      padding: 10px;
      border-top: 1px solid #cccccc;
      cursor: pointer;
    }

    .leaf-nav-search .search-results ul li:hover {
      background-color: #efefef;
    }

    </style>
    <div class="leaf-nav-search">
      <div style="position: relative;">
        <div *ngIf="!isSearching && counter < 0 && search.title"
        style="position: absolute; right: 0px; top: 0px; padding-top: 8px; padding-right: 12px;">
          <i class="fa fa-times" style="cursor: pointer" (click)="clearSearch()"></i>
        </div>
        <div leaf-wait-and-load style="position: absolute; right: 0px; top: 0px; padding-top: 8px; padding-right: 10px;"
          [dots]="3"
          [currentDot]="counter"
          [isLoading]="isSearching">
        </div>
      </div>
      <input class="form-control icon-placeholder "
      placeholder="&#xF002;"
      maxlength="100"
      [class.empty]="!search.title"
      [(ngModel)]="search.title"
      [class.focused]="focused"
      [class.withResults]="search.title && results && results.length > 0"
      (keyup)="onKeyUp()"
      (blur)="onBlur()"
      (focus)="onFocus()">

      <div class="search-results" *ngIf="search.title && results && results.length > 0">
        <ul>
          <li *ngFor="let result of results" style="display: table; width: 100%">
            <span [leaf-nav-employee-search-result]="result" *ngIf="result.type == 'EMPLOYEE'" style="display: table-row;"></span>
          </li>
        </ul>
      </div>

    </div>
  `
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NavSearchInputProvider, },
{type: LoggerService, decorators: [{ type: Inject, args: ['LoggerService', ] }, ]},
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
